<div class="container">
  <div class="row text-center mb-3">
    <div class="col-4 align-content-center col-md-4 d-none d-md-block">
      <span class="fs-16px fw-bold">Centrix Perú</span>
      <div class="logo">
        <img src="assets/logo/logo_.png" alt="Centrix Peru">
      </div>
    </div>
    <div class="col-6 col-md-4">
      <span class="fs-18px fontWeight600">Productos</span><br/>
      <div class="mt-3 fs-14px text-muted">
        <span class="spanLink" (click)="FE()">Facturación electrónica</span><br/>
        <span class="spanLink" (click)="VO()">Sistema de Ventas Online</span><br/>
        <span class="spanLink" (click)="WE()">Web Encuentrame</span><br/>
      </div>
    </div>
    <div class="col-6 col-md-4">
      <span class="fs-18px fontWeight600">Enlaces útiles</span><br/>
      <div class="mt-3 fs-14px text-muted">
        <span class="spanLink" (click)="Contacto()">Contáctanos</span><br/>
      </div>
    </div>
  </div>
  <footer class="py-3 bg-white border-top">
    <div class="container d-flex flex-column flex-lg-row justify-content-between align-items-center gap-2">
      <div class="text-muted">Tus facturas electrónicas ayudan a sembrar árboles</div>
      <ul class="nav small">
        <li class="nav-item"><a class="nav-link text-muted">COPYRIGHT © {{ year }} Centrix - Perú</a></li>
      </ul>
    </div>
  </footer>
</div>